module.exports = __webpack_public_path__ + "static/img/777_phase_function_Paper_PointsHejduk_Prediction.df3ac39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/777_phase_function_Paper_PointsHejduk_Prediction.png
// module id = mWK5
// module chunks = 0